import { isDemoMode } from '../utils/demoMode';
import { handleMockApiCall } from './mockApiHandler';

const API_BASE_URL =  'https://api.zakazuj.com/api/v1';
//const API_BASE_URL = 'http://localhost:5000/api/v1'; // Može se koristiti za lokalni development preko env varijable

// Helper funkcija za API pozive
const apiCall = async (endpoint, options = {}) => {
  // Proveri da li je demo mode
  if (isDemoMode()) {
    return handleMockApiCall(endpoint, options);
  }

  const token = localStorage.getItem('token');
  
  const config = {
    headers: {
      'Content-Type': 'application/json',
      ...(token && { Authorization: `Bearer ${token}` }),
      ...options.headers,
    },
    ...options,
  };

  try {
    const response = await fetch(`${API_BASE_URL}${endpoint}`, config);
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      const error = new Error(errorData.error || `HTTP error! status: ${response.status}`);
      error.response = {
        status: response.status,
        data: errorData
      };
      throw error;
    }
    
    return await response.json();
  } catch (error) {
    console.error('API call error:', error);
    // Support both 'Token je istekao' and 'Token je istekao.' variations
    if (error.message === 'Token je istekao' || error.message === 'Token je istekao.') {
      try {
        localStorage.removeItem('token');
      } catch (e) {
        console.warn('Could not remove token from localStorage', e);
      }
      // Hard redirect to login page from a non-react module
      window.location.href = '/login';
    }
    throw error;
  }
};

// API metode
export const api = {

  baseURL: API_BASE_URL,

  // GET request
  get: (endpoint) => apiCall(endpoint),
  
  // POST request
  post: (endpoint, data) => apiCall(endpoint, {
    method: 'POST',
    body: JSON.stringify(data),
  }),
  
  // PUT request
  put: (endpoint, data) => apiCall(endpoint, {
    method: 'PUT',
    body: JSON.stringify(data),
  }),
  
  // DELETE request
  delete: (endpoint) => apiCall(endpoint, {
    method: 'DELETE',
  }),

  deleteWithBody: (endpoint, data) => apiCall(endpoint, {
    method: 'DELETE',
    body: JSON.stringify(data),
  }),
  
  // PATCH request
  patch: (endpoint, data) => apiCall(endpoint, {
    method: 'PATCH',
    body: JSON.stringify(data),
  }),
};

export default api;




